module.exports = __webpack_public_path__ + "static/media/icon.ff67bc44.png";